import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalSheet } from '../ui/ModalSheet';

const SESSION_KEY = 'uo.wallet.idleLoginNotice.dismissed';

function readDismissed(): boolean {
  try {
    return sessionStorage.getItem(SESSION_KEY) === '1';
  } catch {
    return false;
  }
}

function markDismissed(): void {
  try {
    sessionStorage.setItem(SESSION_KEY, '1');
  } catch {
    /* ignore */
  }
}

/** Homepage reminder only — no 90-day auto-close logic. */
export function IdleLoginNoticeModal() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!readDismissed()) setOpen(true);
  }, []);

  function close() {
    markDismissed();
    setOpen(false);
  }

  return (
    <ModalSheet open={open} onClose={close} title={t('wallet.idleNotice.title')}>
      <p className="text-sm leading-6 text-text-primary">
        {t('wallet.idleNotice.body')}
      </p>
      <button type="button" className="btn-primary mt-5" onClick={close}>
        {t('wallet.idleNotice.ok')}
      </button>
    </ModalSheet>
  );
}
